// extracted by mini-css-extract-plugin
export var alignDiscLeft = "n_qp d_fp d_bG d_dv";
export var alignLeft = "n_qq d_fp d_bG d_dv";
export var alignDiscCenter = "n_qr d_fq d_bD d_dw";
export var alignCenter = "n_bP d_fq d_bD d_dw";
export var alignDiscRight = "n_qs d_fr d_bH d_dx";
export var alignRight = "n_qt d_fr d_bH d_dx";
export var footerContainer = "n_qv d_dW d_bW";
export var footerContainerFull = "n_qw d_dT d_bW";
export var footerHeader = "n_kf d_kf";
export var footerTextWrapper = "n_qx d_w";
export var footerDisclaimerWrapper = "n_km d_km d_ck";
export var badgeWrapper = "n_qy d_w d_bz d_bP d_bF d_bJ";
export var verticalTop = "n_qz d_bz d_bJ d_bN d_bL";
export var wide = "n_qB d_cy";
export var right = "n_qC d_bK";
export var line = "n_fk d_fl d_cv";
export var badgeDisclaimer = "n_qD d_bC d_bP d_bJ";
export var badgeContainer = "n_qF d_bz d_bH d_bP";
export var badge = "n_qG";
export var padding = "n_qH d_c7";
export var end = "n_qJ d_bH";
export var linkWrapper = "n_qK d_dB";
export var link = "n_mZ d_dB";
export var colWrapper = "n_qL d_cx";
export var consent = "n_f d_f d_bC d_bP";
export var disclaimer = "n_qM d_bz d_bJ";
export var media = "n_qN d_bx d_dy";
export var itemRight = "n_qP";
export var itemLeft = "n_qQ";
export var itemCenter = "n_qR";
export var exceptionWeight = "n_qS q_rl";